// extracted by mini-css-extract-plugin
export default {"data__empty":"no-data_data__empty__bXDkG"};